import React from "react";
import { Pagination } from "react-bootstrap";
import { useSelector } from "react-redux";
import { push, setParam } from "../../api/search/filterUrlMaker";
import { formatInt } from "lib/numberFormat";
import { addElipsis } from "./addElipsis";
import { PAGE_SIZE } from "../../redux/slices/api/initialisePreferences";

export const PaginationControl = ({ records = 0 }) => {
  const { pageFrom } = useSelector((state) => state.filter);
  const pageSize = useSelector((state) => state.preferences[PAGE_SIZE][0]);
  const numPages = Math.ceil(records / pageSize);
  const n = parseInt(pageFrom && pageFrom.From ? pageFrom.From : 1);

  let pages = [1, n - 1, n, n + 1, n + 2]
    .sort((i, j) => i - j)
    .filter((i) => i > 0)
    .filter((i) => i <= numPages)
    .filter((v, i, a) => a.indexOf(v) === i); //unqiue pages only

  pages = addElipsis(pages);

  return (
    <section className="d-flex w-100 overflow-hidden">
      <Pagination className="mx-auto" size={n > 100 && pages.length > 6 && "sm"}>
        {pages.map((page, key) => (
          <Pagination.Item
            key={key}
            active={page === n}
            disabled={isNaN(page)}
            onClick={() => {
              push(setParam("From", page));
              window.scrollTo(0, 0);
            }}
          >
            <span>{Number.isInteger(page) ? formatInt(page) : page}</span>
          </Pagination.Item>
        ))}
      </Pagination>
    </section>
  );
};
